import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({ name:"", image:"", order:1, active:true });
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/categories").then((r)=>setCats(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing) await api.put(`/admin/categories/${editing.id}`, form);
      else await api.post("/admin/categories", form);
      toast.success(editing ? "Categoria atualizada" : "Categoria criada");
      setForm({ name:"", image:"", order:1, active:true });
      setEditing(null);
      load();
    } catch { toast.error("Erro ao salvar"); }
  };

  const del = async (c) => {
    if (!window.confirm(`Excluir "${c.name}"?`)) return;
    await api.delete(`/admin/categories/${c.id}`);
    toast.success("Excluída");
    load();
  };

  return (
    <div className="space-y-5" data-testid="admin-categories">
      <h1 className="font-serif text-3xl text-[#4A3B40]">Categorias</h1>

      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5 h-fit">
          <h3 className="font-serif text-lg text-[#4A3B40] mb-3">{editing?"Editar":"Nova categoria"}</h3>
          <div className="space-y-3">
            <input className="cf" placeholder="Nome" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} data-testid="cat-name" />
            <input className="cf" placeholder="URL da imagem" value={form.image} onChange={(e)=>setForm({...form, image:e.target.value})} />
            <input className="cf" type="number" placeholder="Ordem" value={form.order} onChange={(e)=>setForm({...form, order:Number(e.target.value)})} />
            <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.active} onChange={(e)=>setForm({...form, active:e.target.checked})} /> Ativa</label>
            <div className="flex gap-2">
              {editing && <button onClick={()=>{setEditing(null); setForm({name:"",image:"",order:1,active:true});}} className="btn-lara-outline flex-1">Cancelar</button>}
              <button onClick={save} className="btn-lara flex-1" data-testid="cat-save">{editing?"Atualizar":"Criar"}</button>
            </div>
          </div>
          <style>{`.cf{width:100%;border:1px solid #F9E1E8;background:#FFF9FA;border-radius:12px;padding:10px 14px;outline:none;font-size:14px}.cf:focus{border-color:#C9708B}`}</style>
        </div>

        <div className="md:col-span-2 space-y-2">
          {cats.map((c) => (
            <div key={c.id} className="bg-white rounded-2xl border border-[#F9E1E8] p-4 flex items-center gap-4" data-testid={`cat-row-${c.slug}`}>
              <img src={c.image} className="w-14 h-14 rounded-xl object-cover bg-[#F9E1E8]" alt="" />
              <div className="flex-1">
                <p className="font-serif font-semibold text-[#4A3B40]">{c.name}</p>
                <p className="text-xs text-[#8C7A80]">/{c.slug} • Ordem {c.order}</p>
              </div>
              <button onClick={()=>{setEditing(c); setForm({name:c.name, image:c.image||"", order:c.order||1, active:c.active!==false});}} className="text-[#C9708B] p-2"><Edit className="w-4 h-4" /></button>
              <button onClick={()=>del(c)} className="text-[#E57373] p-2"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
